import React from 'react';

import { useTheme } from '@mui/material/styles';
import { Box, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import KeyIndicator from 'common/components/KeyIndicator';
import { numberFormat } from 'common/utils/helpers';

import { getProjectsChartSettings } from '../helpers';
import * as selectors from '../selectors';

const ProjectsTotals = ({
    currencyLocale,
    projectCounters,
    readyPlaceholder,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const chartConfig = getProjectsChartSettings(
        projectCounters.categories,
        currencyLocale,
        projectCounters.series,
    );

    return (
        <Grid container mt={2}>
            <Grid size={{ lg: 8, xs: 18 }}>
                <Chart
                    height="250"
                    options={{
                        ...chartConfig.options,
                        theme: { mode: theme.palette.mode },
                    }}
                    series={chartConfig.series}
                    type="bar"
                />
            </Grid>

            <Grid size={{ lg: 4, xs: 18 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={2}
                    sx={{ width: '100%' }}
                >
                    <KeyIndicator
                        isLoading={readyPlaceholder}
                        title={t('Total projects')}
                        value={numberFormat(projectCounters.projects_totals, {
                            decimals: 0,
                            locale: currencyLocale,
                            style: 'decimal',
                        })}
                        widthIcon="20px"
                    />
                </Box>
            </Grid>
        </Grid>
    );
};

const mapStateToProps = createStructuredSelector({
    projectCounters: selectors.getProjectsCountersData,
});

ProjectsTotals.propTypes = {
    currencyLocale: PropTypes.string,
    projectCounters: PropTypes.object,
    readyPlaceholder: PropTypes.bool,
};

export default connect(mapStateToProps, null)(ProjectsTotals);
